import React, {useState, useMemo,useEffect,useCallback} from "react";
import { useParams } from "react-router-dom";
import NewTab from "../component/NewTab";
import InterSectionObserver from '../../../common/components/intersection/InterSectionObserver';
import useFetch from "@common/hooks/fetch/useFetch";
import {getLitList} from "@common/services/restapi/lit";
import {Moments} from "@common/utils/date/moments";
import Lit from "@common/enums/Lit.enums";
import Page from "@common/enums/Page.enums";
import {convertPath} from "@common/utils/path/linkPath";

const LIT_MENU = [Lit.paper, Lit.report];

function litList() {
  const {category} = useParams();
  const [litList, setLitList] = useState([]);
  const [page, setPage] = useState(Page.page.defaultPage);

  const searchQuery = useMemo(() => {
    return {
      category: category,
      pageNumber: page,
      pageSize: Page.size.defaultSize
    }
  },[page]);

  const {data, loading : dataLoading} = useFetch(() => getLitList(category, searchQuery), [searchQuery], {});

  useEffect(() => {
    if (data && data.litList) {
      setLitList(litList.concat(data.litList));
    }
  }, [data]);

  const handleObserver = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  const handleTabMove = useCallback((litType) => {
    window.location.href = convertPath('/lit/' + litType);
  }, []);

  return (
    <>
      <div className="common-header--top">
        <h3 className="header-title">전문자료</h3>
      </div>

      <section className="common-body--list">
        <NewTab
          additionalClassName="mb-4"
          selectedThing={Lit.enumValueOf(category).enumKey}
          setSelectedThing={handleTabMove}
          thingsList={LIT_MENU}
        />
          <div className="journal-list">
            {litList && litList.map((paper, index) => {
              return (
                <a href={convertPath(`/lit/${category}/${paper.ukey}`)} className="thumbnail-card journal">
                  <div className="title">{paper.title}</div>
                  <div className="row-box">
                    <div className="publisher">{paper.publisher}</div>
                    <div className="date">{Moments.Format(paper.wdate, 'yyyy.MM.DD')}</div>
                  </div>
                </a>
              )
            })}
          </div>
        <InterSectionObserver dataLoading={dataLoading} onHandleObserver={handleObserver}/>
      </section>
    </>
  )
}

export default litList;
